import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { useNavigate } from 'react-router';

const useRenewalNavigation = () => {
	const navigate = useNavigate();
	const goToRenewalHome = () => {
		navigate(ROUTE_PATHS.renewalMakeAChangeSummary);
	};

	return { goToRenewalHome };
};

export default useRenewalNavigation;
